import { getStyle } from "./getStyle.js";
export function getForm(options = {}) {
    const { id = `instrument-${crypto.randomUUID()}` } = options;
    return {
        id,
        html: `<style>${getStyle(id)}</style>
<div id="${id}">
  <div class="settings">
    <div class="setting-item setting-holder">
      <label for="${id}-holder">Holder number</label>
      <input type="number" id="${id}-holder" class="holder-input" />
    </div>
    <div class="setting-item setting-solvent">
      <label for="${id}-solvent">Solvent</label>
      <select id="${id}-solvent" class="solvent-select"></select>
    </div>
    <div class="setting-item setting-item-inline">
      <label>
        <input type="checkbox" class="delete-existing-holder-toggle" />
        Delete existing holder
      </label>
    </div>
    <div class="setting-item setting-item-inline">
      <label>
        <input type="checkbox" class="auto-import-toggle" />
        auto import
      </label>
    </div>
  </div>
  <div id="tabs" class="tabs"></div>
  <div id="form-container" class="form-container"></div>
</div>`,
    };
}
//# sourceMappingURL=getForm.js.map